class FeaturedCollectionsNav extends HTMLElement {
  constructor() {
    super();
    this.mainGrid = this.querySelector("[data-main-grid]");
    this.textLinks = this.querySelector("[data-text-links]");
    this.nestedTriggers = this.querySelectorAll("[data-nested-trigger]");
    this.nestedMenus = this.querySelectorAll("[data-nested-menu]");
    this.backButtons = this.querySelectorAll("[data-nested-back]");

    this.init();
  }

  init() {
    this.nestedTriggers.forEach((trigger) => {
      trigger.addEventListener("click", (e) => {
        e.preventDefault();
        const index = trigger.dataset.nestedIndex;
        this.showNestedMenu(index);
      });
    });

    this.backButtons.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        this.hideNestedMenus();
      });
    });

    this.initInnerExpands();
  }

  initInnerExpands() {
    this.addEventListener("click", (e) => {
      const expandButton = e.target.closest("[data-inner-expand]");
      if (!expandButton) return;

      e.preventDefault();
      const nestedList = expandButton.parentElement.querySelector(
        "[data-inner-nested-list]"
      );

      if (!nestedList) return;

      const isExpanded = expandButton.getAttribute("aria-expanded") === "true";

      if (isExpanded) {
        const currentHeight = nestedList.offsetHeight;
        nestedList.style.height = currentHeight + "px";

        expandButton.setAttribute("aria-expanded", "false");
        nestedList.setAttribute("aria-hidden", "true");

        requestAnimationFrame(() => {
          nestedList.style.height = "0px";
        });
      } else {
        expandButton.setAttribute("aria-expanded", "true");
        nestedList.setAttribute("aria-hidden", "false");
        nestedList.style.height = "auto";
        const height = nestedList.offsetHeight;
        nestedList.style.height = "0px";

        requestAnimationFrame(() => {
          nestedList.style.height = height + "px";
        });
      }
    });
  }

  showNestedMenu(index) {
    const menu = this.querySelector(
      `[data-nested-menu][data-nested-index="${index}"]`
    );
    if (!menu) return;

    if (this.mainGrid) {
      this.mainGrid.setAttribute("data-hidden", "true");
    }

    if (this.textLinks) {
      this.textLinks.setAttribute("data-hidden", "true");
    }

    menu.setAttribute("aria-hidden", "false");

    menu.setAttribute("aria-hidden", "false");
  }
  hideNestedMenus() {
    this.nestedMenus.forEach((menu) => {
      menu.setAttribute("aria-hidden", "true");
    });

    if (this.mainGrid) {
      this.mainGrid.removeAttribute("data-hidden");
    }

    if (this.textLinks) {
      this.textLinks.removeAttribute("data-hidden");
    }
  }
}

if (!customElements.get("featured-collections-nav")) {
  customElements.define("featured-collections-nav", FeaturedCollectionsNav);
}
